import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';

import { Breakpoint } from './index.types';
import { getBreakpoint } from './index.utils';

const useBreakpoint = () => {
  const { width } = useWindowDimensions();
  const breakpoint = useMemo<Breakpoint>(() => getBreakpoint(width), [width]);

  return breakpoint;
};

export default useBreakpoint;
